import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ConfirmDialogModule, CalendarModule, FileUploadModule, InputMaskModule, DataTableModule } from 'primeng/primeng';

import { Ng2BRPipesModule } from 'ng2-brpipes';

import { EmpregoNaPistaSharedModule } from '../shared/emprego-na-pista-shared.module';

import { CfcRouting } from './cfc.routing';

import { CfcService } from './cfc.service';
import { EnderecoService } from '../shared/services/endereco.service';

import { AnalisarCredenciamentoCfcComponent } from './analisar-credenciamento-cfc/analisar-credenciamento-cfc.component';
import { CadastroCfcFormComponent } from './cadastro-cfc-form/cadastro-cfc-form.component';
import { GerarRequerimentoCfcComponent } from './gerar-requerimento-cfc/gerar-requerimento-cfc.component';
import { GerenciarCfcComponent } from './gerenciar-cfc/gerenciar-cfc.component';
import { VisualizarCfcComponent } from './visualizar-cfc/visualizar-cfc.component';
import { VisualizarEditaisCfcComponent } from './visualizar-editais-cfc/visualizar-editais-cfc.component';
import { VisualizarHistoricoAnalisesCfcComponent } from './visualizar-historico-cfc/visualizar-historico-cfc.component';
import { GerenciarTermoAditivoCfcComponent } from './gerenciar-termo-aditivo-cfc/gerenciar-termo-aditivo-cfc.component';
import { CadastrarTermoAditivoCfcComponent } from './cadastrar-termo-aditivo-cfc/cadastrar-termo-aditivo-cfc.component';
import { VisualizarTermoAditivoCfcComponent } from './visualizar-termo-aditivo-cfc/visualizar-termo-aditivo-cfc.component';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule, ReactiveFormsModule,

        CfcRouting,

        ConfirmDialogModule, CalendarModule, FileUploadModule, InputMaskModule, DataTableModule,

        Ng2BRPipesModule,

        EmpregoNaPistaSharedModule
    ],
    providers: [ CfcService, EnderecoService ],
    declarations: [
        AnalisarCredenciamentoCfcComponent,
        CadastroCfcFormComponent,
        GerarRequerimentoCfcComponent,
        GerenciarCfcComponent,
        VisualizarCfcComponent,
        VisualizarEditaisCfcComponent,
        VisualizarHistoricoAnalisesCfcComponent,
        GerenciarTermoAditivoCfcComponent,
        CadastrarTermoAditivoCfcComponent,
        VisualizarTermoAditivoCfcComponent
    ],
})
export class CfcModule { }



// WEBPACK FOOTER //
// ./src/app/components/cfc/cfc.module.ts